import gql from "graphql-tag";

// All three mutations are Super-Admin only on the backend — they return
//   "unauthorized: super admin access required" otherwise. The frontend
//   gates the UI accordingly.

export const CREATE_CMZ_LIBRARY_QUOTE = gql`
  mutation CreateCMZLibraryQuote($input: CreateCMZLibraryQuoteInput!) {
    createCMZLibraryQuote(input: $input) {
      id
      source
      category
      arabicText
      translation
      transliteration
      reference
      surahNumber
      ayahNumber
      tags
      labels
      isVerified
      isActive
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_CMZ_LIBRARY_QUOTE = gql`
  mutation UpdateCMZLibraryQuote($input: UpdateCMZLibraryQuoteInput!) {
    updateCMZLibraryQuote(input: $input) {
      id
      source
      category
      arabicText
      translation
      transliteration
      reference
      surahNumber
      ayahNumber
      tags
      labels
      isVerified
      isActive
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_CMZ_LIBRARY_QUOTE = gql`
  mutation DeleteCMZLibraryQuote($id: ID!) {
    deleteCMZLibraryQuote(id: $id)
  }
`;

// Quote of the Day — Super-Admin only. The backend upserts by date (one QOTD
//   per day; re-scheduling replaces) and broadcasts QOTD_SCHEDULE_UPDATE to
//   every connected TV, so the client does not push anything itself.
export const SCHEDULE_QOTD = gql`
  mutation ScheduleQuoteOfTheDay($input: ScheduleQuoteOfTheDayInput!) {
    scheduleQuoteOfTheDay(input: $input) {
      id
      date
      quoteId
      isGlobal
    }
  }
`;

export const DELETE_SCHEDULED_QOTD = gql`
  mutation DeleteScheduledQuoteOfTheDay($date: String!) {
    deleteScheduledQuoteOfTheDay(date: $date)
  }
`;
